import { Box, IconButton, Tag, Text, Title } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { Repeater, Stack } from 'commons/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

function ItemSkeleton(): JSX.Element {
  return (
    <Box display="flex" flexDirection="row">
      <Box width="100%">
        <Stack column align="flex-start" spacing="tight">
          <Text.Skeleton width="150px" />
          <Text.Skeleton width="100px" />
          <Tag.Skeleton height="1rem" />
        </Stack>
      </Box>
      <Box width="auto">
        <Box width="fit-content">
          <Stack spacing="tight">
            <IconButton.Skeleton height="2rem" width="2rem" />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}

function PartnersListMobileSkeleton() {
  const t = useTranslationConfigurations('partnersListComponent');
  return (
    <>
      <Title as="h4">{t('title')}</Title>
      <DataList>
        <Repeater times={1} item={() => <ItemSkeleton />} />
      </DataList>
    </>
  );
}

export default PartnersListMobileSkeleton;
